<mat-drawer-container class="sidebar-container mat-elevation-z8">
  <mat-drawer #drawer mode="side" [opened]="openSidenav" class="pt-3">

    <div class="row m-2 mat-elevation-z8" style=" left: 12%; position: fixed; z-index: 900;">
      <button class="col-6" id="" color="primary" mat-button  (click)="openSearchBar()">
        <mat-icon class="mat-18" *ngIf="!getSearchBar">search</mat-icon>
        <mat-icon class="mat-18 text-success" *ngIf="getSearchBar">search</mat-icon>
      </button>
      <button class="col-6" id="closeBtn"  color="primary" mat-raised-button  (click)="btnAff()" (click)="drawer.toggle()">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
      </button>
    </div>

    <div id="startOfSidebar" #startOfSidebar></div>

    @defer () {
      <mat-form-field appearance="outline" class="m-1 mt-5" *ngIf="getSearchBar">
        <mat-label>Recherche </mat-label>
        <input
        type="text"
        matInput
        [formControl]="search"
        placeholder="Votre recherche"
        [matAutocomplete]="auto"
        #searchInput
        >
        <mat-icon matSuffix *ngIf="search.getRawValue()==''" >search</mat-icon>
        <mat-icon matSuffix class="text-danger" *ngIf="search.getRawValue()!=''" (click)="resetForm()">close</mat-icon>

        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          @for (item of filteredOption | async; track item) {
            <mat-option [value]="item.name" *ngIf="getRigth(item?.rigth)" (click)="goToView(item.path)">{{ item.name }}</mat-option>
            <mat-divider></mat-divider>
          }
        </mat-autocomplete>
      </mat-form-field>
    }
    <!--------------sidebarOption-------------->
    @defer () {
      <app-sidebar-option class="mt-5"></app-sidebar-option>
    }
    <!--------------sidebarOption-------------->

  </mat-drawer>

  <mat-drawer-content>
      @if(aff){
        <div id="sidenav" class="mat-elevation-z8">
          <button class="sidebar_btn mt-3" color="primary" mat-button  (click)="btnAff()" (click)="drawer.toggle()" >
            <mat-icon>menu</mat-icon>
          </button>
        </div>
      }

     <!--------------content-------------->
     <div class="container-fluid sidebar_content " [style]="myContentSytle">
        <alert></alert>
        <router-outlet ></router-outlet>
     </div>
  </mat-drawer-content>

</mat-drawer-container>
